<template>
  <!--breadcrumb-->
  <ol class="location">
    <li 
      v-for="(breadcrumb, index) in breadcrumbs" 
      :key="breadcrumb.menuNo || breadcrumb.menuId || index"
      :class="{ 'home': index === 0 }"
    >
      {{ breadcrumb.menuNm }}
    </li>
  </ol>
  <div class="area_title">
    <h1 class="title">{{ title }}</h1>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  breadcrumbs: {
    type: Array,
    default: () => []
  }
})
</script>

<style scoped>
/* 필요시 스타일 추가 */
</style>
